module.exports = __webpack_public_path__ + "static/media/Muli-ExtraBold.a16b49a3.ttf";